import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=2f500210&scoped=true&"
import script from "./TheSidebar.vue?vue&type=script&lang=js&"
export * from "./TheSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TheSidebar.vue?vue&type=style&index=1&id=2f500210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f500210",
  null
  
)

export default component.exports